var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.optionsFinal.length > 1)?_c('div',{staticClass:"toggle"},_vm._l((_vm.optionsFinal),function(option){return _c('div',{key:option.value,staticClass:"toggle-item",class:{'is-active': option.value === _vm.model},on:{"click":function($event){return _vm.onClick(option.value)}}},[_vm._v(" "+_vm._s(option.text)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }